export const isEmpty = (value) => value.trim() === '';
export const isValidString = (value) => !isEmpty(value) && isNaN(value);
export const isValidPhoneNumber = (value) =>
    !isEmpty(value) && !isNaN(value) && value.length === 10;
export const isFiveChars = (value) => value.trim().length === 5;
export const isNotNull = (value) => value !== null;
